import { defaultDriverAge } from "@/schemas/carSearchSchema";

const defaultPickup = new Date();
defaultPickup.setDate(defaultPickup.getDate() + 1);

const defaultDropOff = new Date();
defaultDropOff.setDate(defaultDropOff.getDate() + 4);

// Araç için initial state - sadece gerekli alanlar
export const initialState = {
  loading: false,
  pickUpDate: defaultPickup,
  dropOffDate: defaultDropOff,
  pickUpTime: '10:00',
  dropOffTime: '10:00',
  driverAge: defaultDriverAge,
  isDifferentLocation: false,
  pickUpLocation: null,
  dropOffLocation: null,
  latestCarSearches: null,
  popularLocations: null,
  publicHolidays: [],
};

export const carSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_PICKUP_DATE":
      return { ...state, pickUpDate: action.payload };
    case "SET_DROPOFF_DATE":
      return { ...state, dropOffDate: action.payload };
    case "SET_PICKUP_TIME":
      return { ...state, pickUpTime: action.payload };
    case "SET_DROPOFF_TIME":
      return { ...state, dropOffTime: action.payload };
    case "SET_PICKUP_LOCATION":
      return { ...state, pickUpLocation: action.payload };
    case "SET_DROPOFF_LOCATION":
      return { ...state, dropOffLocation: action.payload };
    case "SET_IS_DIFFERENT_LOCATION":
      return { ...state, isDifferentLocation: action.payload };
    case "SET_DRIVER_AGE":
      return { ...state, driverAge: action.payload };
    case "SET_LATEST_CAR_SEARCHES":
      return { ...state, latestCarSearches: action.payload };
    case "SET_POPULAR_LOCATIONS":
      return { ...state, popularLocations: action.payload };
    case "SET_PUBLIC_HOLIDAYS":
      return { ...state, publicHolidays: action.payload };
    default:
      return state;
  }
};

export default carSearchReducer;
